import {
  memberJoin_CenterContent,
  memberJoin_Completed,
  memberJoin_CurrentStep,
  memberJoin_ErrorPage,
  memberJoin_ErrorUpdating,
} from './selectors';
import { Component, HostListener, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import {
  commonState_IsFetching,
  commonState_LatestJourney,
} from 'src/app/store/common/common.selectors';
import {
  SetErrorPageDataAction,
} from './actions';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Helper,
} from '@ifaa-components/ui-components';
import { ToastrService } from 'ngx-toastr';
import {
  AsyncPipe,
  NgClass,
  NgIf,
} from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AnimateCssDirective } from 'src/app/directives/animatecss.directive';
import { NmjInitialDataComponent } from './steps/nmj-initial-data/nmj-initial-data.component';
import { NmjDetailsComponent } from './steps/nmj-details/nmj-details.component';
import { NmjMobileVerificationComponent } from './steps/nmj-mobile-verification/nmj-mobile-verification.component';
import { NmjTermsConditionsComponent } from './steps/nmj-terms-conditions/nmj-terms-conditions.component';
import { NmjTfnComponent } from './steps/nmj-tfn/nmj-tfn.component';
import { NmjRollinComponent } from './steps/nmj-rollin/nmj-rollin.component';
import { NmjFinishedComponent } from './nmj-finished/nmj-finished.component';
import { NmjInfoDisplayComponent } from './nmj-info-display/nmj-info-display.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { combineLatest } from 'rxjs';
import { NmjInvestmentsComponent } from './steps/nmj-investments/nmj-investments.component';
import { NmjReviewComponent } from './steps/nmj-review/nmj-review.component';

declare var window: any;
declare var fbq: any;

@Component({
  selector: 'app-member-join',
  templateUrl: './member-join.component.html',
  styleUrls: ['./member-join.component.scss'],
  imports: [
    AsyncPipe,
    NgIf,
    NgClass,
    MatProgressBarModule,
    AnimateCssDirective,
    NmjInitialDataComponent,
    NmjDetailsComponent, 
    NmjMobileVerificationComponent,
    NmjTermsConditionsComponent,
    NmjTfnComponent,
    NmjRollinComponent,
    NmjFinishedComponent,
    NmjInfoDisplayComponent, 
    MatProgressSpinner,
    NmjInvestmentsComponent,
    NmjReviewComponent
  ],
})
export class MemberJoinComponent
  extends ComponentBase
  implements OnInit, OnDestroy {

  @HostListener('window:resize', ['$event'])
  
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  public innerWidth: any;

  isLoading$ = this.store.pipe(select(commonState_IsFetching));
  latestJourney$ = this.store.pipe(select(commonState_LatestJourney));
  currentStep$ = this.store.pipe(select(memberJoin_CurrentStep));
  errorPage$ = this.store.pipe(select(memberJoin_ErrorPage));
  errorUpdating$ = this.store.pipe(select(memberJoin_ErrorUpdating));
  completed$ = this.store.pipe(select(memberJoin_Completed));
  centerContent$ = this.store.pipe(select(memberJoin_CenterContent));

  helper = new Helper();
  currentFragment: string = null;
  currentIndex: number = null;
  totalSteps: number = 0;
  progress: number = 10;

  constructor(
    public store: Store<AppState>,
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
    this.innerWidth = window.innerWidth;

    // Subscribe to latest journey to get total journey length
    this.sub = this.latestJourney$.subscribe((journey) => {
      if (journey) {
        this.totalSteps = journey.journeySteps.length;
      }
    })

    // Subscribe to current step to set progress bar values
    this.sub = combineLatest([this.currentStep$, this.completed$]).subscribe(x => {
      this.currentIndex = x[0];

      var stepName = 'step-' + x[0].toString();

      if (x[1]) {
        stepName = 'done';
        this.progress = 100;
        this.confetti();
      }
      else{
        this.setProgressBarValue();
      }

      this.router.navigate(['/'], { fragment: stepName });
      window.scroll(0, 0);
    });

    // Subscription to route fragments to update route
    this.route.fragment.subscribe((fragment) => {
      if (window && window.dataLayer) {
        window.dataLayer.push({
          currentPage: fragment,
          pageUrl: location.href,
        });
        history.pushState(
          { url: location.href },
          'New URL: ' + location.href,
          location.href
        );
        var eventname = null;
        switch (fragment) {
          case 'step-0':
            eventname = 'Lead';
            break;
          case 'done':
            eventname = 'Purchase';
            break;
          default:
        }
        if (fbq) fbq('track', eventname);
      }
      this.currentFragment = fragment;
    });
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  onCloseErrorPageClick() {
    setTimeout(() => {
      this.store.dispatch(SetErrorPageDataAction({ data: null }));
    }, 0);
  }

  async setProgressBarValue() {
    // default to 10% progress until after details step
    if (this.currentIndex > 0) {
      this.progress = (this.currentIndex / this.totalSteps) * 100;
    }
  }

  frameId: string;
  x: number;
  y: number;

  confetti() {
    window.requestAnimationFrame =
      window.requestAnimationFrame || window.webkitRequestAnimationFrame;

    var canvas = document.querySelector('canvas');
    canvas.style['z-index'] = '10';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    var ctx = canvas.getContext('2d');
    ctx.globalCompositeOperation = 'source-over';
    var particles = [];
    var pIndex = 0;
    var x, y, frameId;

    function Dot(x, y, vx, vy, color) {
      this.x = x;
      this.y = y;
      this.vx = vx;
      this.vy = vy;
      this.color = color;
      particles[pIndex] = this;
      this.id = pIndex;
      pIndex++;
      this.life = 0;
      this.maxlife = 600;
      this.degree = getRandom(0, 360);
      this.size = Math.floor(getRandom(8, 15));
    }

    Dot.prototype.draw = function (x, y) {
      this.degree += 1;
      this.vx *= 0.99;
      this.vy *= 0.999;
      this.x += this.vx + Math.cos((this.degree * Math.PI) / 180);
      this.y += this.vy;
      this.width = this.size;
      this.height = Math.cos((this.degree * Math.PI) / 45) * this.size;
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.moveTo(this.x + this.x / 2, this.y + this.y / 2);
      ctx.lineTo(
        this.x + this.x / 2 + this.width / 2,
        this.y + this.y / 2 + this.height
      );
      ctx.lineTo(
        this.x + this.x / 2 + this.width + this.width / 2,
        this.y + this.y / 2 + this.height
      );
      ctx.lineTo(this.x + this.x / 2 + this.width, this.y + this.y / 2);
      ctx.closePath();
      ctx.fill();
      this.life++;
      if (this.life >= this.maxlife) {
        delete particles[this.id];
      }
    };
    window.addEventListener('resize', function () {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      x = canvas.width / 2;
      y = canvas.height / 2;
    });
    function getColor() {
      var arr = ['teal', '#80a1da', '#8fdad1', '#1e184f', '#a014e6', '#41085e'];
      const randomIndex = Math.floor(Math.random() * arr.length);

      // get random item
      const item = arr[randomIndex];

      return item;
    }
    function loop() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (frameId % 3 == 0) {
        new Dot(
          canvas.width * Math.random() -
          canvas.width +
          (canvas.width / 2) * Math.random(),
          -canvas.height / 2,
          getRandom(4, 8),
          getRandom(5, 9),
          getColor()
        );
        new Dot(
          canvas.width * Math.random() +
          canvas.width -
          canvas.width * Math.random(),
          -canvas.height / 2,
          -1 * getRandom(4, 8),
          getRandom(5, 9),
          getColor()
        );
      }
      for (var i in particles) {
        if (parseInt(i) % 2 == 0) {
          particles[i].draw();
        }
      }
      frameId = requestAnimationFrame(loop);
    }

    loop();

    function getRandom(min, max) {
      return Math.random() * (max - min) + min;
    }
  }
}
